// Local y Desarrollo
// export const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3012/idiomas/' : 'https://desarrollospi.quimica.unam.mx:3012/idiomas'
// export const baseURLfiles = process.env.NODE_ENV === 'development' ? 'http://localhost/SPI/idiomas.quimica.unam.mx/src/assets' : 'https://desarrollospi.quimica.unam.mx/idiomas.quimica.unam.mx/src/assets'

//// Prod
export const baseURL = 'https://api.quimica.unam.mx/tureli/idiomas/'
export const baseURLfiles = 'https://idiomas.quimica.unam.mx/'

export const URL_RECOVERY_PASSWORD = 'https://aura.quimica.unam.mx/auth/recuperar-password'


export const errorResponse = { replyCode: 500, replyText: 'Error desconocido, contactar a Planeación' }

export const replyText500 = "Error al intentar conectar con el servidor. Intente más tarde, si el error continúa, contacte al administrador"

export const definido = (value) => value !== undefined && value !== '' && value !== null

export const arrayDefinido = (value) => Array.isArray(value) && value.length > 0

export const objetoDefinido = (value) => definido(value) && Object.keys(value).length > 0
